import { Box, Image } from '@jfs/ui-new'
import DottedImage, { dottedImageTypes } from '../../comps/ImageDotted'
import { AnimatedDevice } from './AnimatedDevice'

export const Devices = ({ isMobile, collapseAnimation, expandAnimation, setDeviceOffset, setDeviceHeight }: any) => {
  const pgApp = require('../../assets/images/pg-app.png')
  const jioDevice = require('../../assets/images/jio-device.png')
  const qr = require('../../assets/images/qr-cutout.png')

  return (
    <Box
      justify="center"
      align={'center'}
      onLayout={(evt: any) => [
        setDeviceOffset(evt?.nativeEvent?.layout?.top),
        setDeviceHeight(evt?.nativeEvent?.layout?.height),
      ]}>
      <Box h={120} w={120} alignSelf={'center'}>
        <DottedImage position={dottedImageTypes.default} isDark={false} size={120} />
      </Box>
      <Box flexDirection={'row'} onPress={isMobile ? undefined : () => {}} underlayColor={'TRANSPARENT'}>
        <Box marginRight={isMobile ? undefined : -60}>
          <AnimatedDevice
            src={jioDevice}
            width={isMobile ? 160 : 320}
            height={isMobile ? 200 : 440}
            animateFromLeft={true}
            resizeMode={'contain'}
            expandAnimation={expandAnimation}
            collapseAnimation={collapseAnimation}
          />
        </Box>
        <Box marginTop={-64}>
          <Image source={pgApp} height={isMobile ? 270 : 500} width={isMobile ? 188 : 350} />
        </Box>
        <Box marginLeft={isMobile ? undefined : -60} zIndex={-10}>
          <AnimatedDevice
            src={qr}
            width={isMobile ? 160 : 320}
            height={isMobile ? 180 : 420}
            animateFromLeft={false}
            resizeMode={'contain'}
            expandAnimation={expandAnimation}
            collapseAnimation={collapseAnimation}
          />
        </Box>
      </Box>
    </Box>
  )
}
